module.exports = __webpack_public_path__ + "img/image-1B.c4e168c4.jpg";